import axios from 'axios';
import { viewerTimeZone } from '../helpers/greeting';

// A function, not a constant: window.store is assembled at boot, and an api
// module is imported before that happens.
const base = () => `${window.store.event_backend_api}/overview`;

/**
 * Everything the Overview shows, in one request — so the greeting and the card
 * beneath it cannot disagree about what is on today.
 */
export const fetchOverview = ({ brokerId = '' } = {}) =>
  axios
    // The viewer's zone: "today", the week and "Renews in N days" are theirs (XN-4673).
    .get(base(), { params: { ...(brokerId ? { broker_id: brokerId } : {}), tz: viewerTimeZone() } })
    .then(({ data }) => data.data);
